import { graphql, useStaticQuery } from "gatsby";

import { hydratePressReleases } from "../utils/utils";

export const usePressReleases = () => {
    const { pressReleases } = useStaticQuery(graphql`
        query PressReleasesQuery {
            pressReleases: allContentfulArticle(
                filter: { dummy: { ne: true }, type: { eq: "Press Release" } }
                sort: { publishDate: DESC }
            ) {
                edges {
                    node {
                        slug
                        publishDate
                        title
                        body {
                            raw
                        }
                    }
                }
            }
        }
    `);

    return hydratePressReleases(pressReleases);
};
